import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class LanguageService {
    private language$ = new BehaviorSubject<any>(null);
    sharedLanguage = this.language$.asObservable();

    constructor() {}

    changeLanguageState(language: string) {
        this.language$.next(language)
      }
}